export enum VenueInvoiceType {
  PROVISION_INVOICE = 'venue.invoice.provision.invoice',
  PRINTER_PREMIUM = 'venue.invoice.printer.premium',
  PRINTER_TABLET = 'venue.invoice.printer.tablet',
  SETUP_FEE_99 = 'venue.invoice.setup.fee.99',
  SETUP_FEE_49 = 'venue.invoice.setup.fee.49',
  PRINTER_TABLET_200 = 'venue.invoice.printer.tablet.200',
  PRINTER_TABLET_230 = 'venue.invoice.printer.tablet.230',
}
